/**
 * Common timezone IDs compatible with .NET TimeZoneInfo.Id format
 * Used for converting camera detection timestamps to UTC
 */
export const TIMEZONE_IDS = [
    {
        id: 'UTC',
        label: 'UTC (Coordinated Universal Time)',
        offset: '+00:00'
    },
    {
        id: 'GMT',
        label: 'GMT (Greenwich Mean Time)',
        offset: '+00:00'
    },
    {
        id: 'W. Europe Standard Time',
        label: 'West Europe (GMT+1/+2)',
        offset: '+01:00/+02:00'
    },
    {
        id: 'Central Europe Standard Time',
        label: 'Central Europe (GMT+1/+2)',
        offset: '+01:00/+02:00'
    },
    {
        id: 'Romance Standard Time',
        label: 'Romance (France, Spain, GMT+1/+2)',
        offset: '+01:00/+02:00'
    },
    {
        id: 'E. Europe Standard Time',
        label: 'East Europe (GMT+2/+3)',
        offset: '+02:00/+03:00'
    },
    {
        id: 'GMT Standard Time',
        label: 'GMT Standard (UK, Ireland)',
        offset: '+00:00/+01:00'
    },
    {
        id: 'Eastern European Standard Time',
        label: 'Eastern European (GMT+2/+3)',
        offset: '+02:00/+03:00'
    },
    {
        id: 'Middle East Standard Time',
        label: 'Middle East (GMT+2/+3)',
        offset: '+02:00/+03:00'
    },
    {
        id: 'Moscow Standard Time',
        label: 'Moscow (GMT+3)',
        offset: '+03:00'
    },
    {
        id: 'UTC+3:30',
        label: 'Iran (GMT+3:30/+4:30)',
        offset: '+03:30/+04:30'
    },
    {
        id: 'Caucasus Standard Time',
        label: 'Caucasus (GMT+4)',
        offset: '+04:00'
    },
    {
        id: 'UTC+4:30',
        label: 'Afghanistan (GMT+4:30)',
        offset: '+04:30'
    },
    {
        id: 'Pakistan Standard Time',
        label: 'Pakistan (GMT+5)',
        offset: '+05:00'
    },
    {
        id: 'India Standard Time',
        label: 'India (GMT+5:30)',
        offset: '+05:30'
    },
    {
        id: 'Sri Lanka Standard Time',
        label: 'Sri Lanka (GMT+5:30)',
        offset: '+05:30'
    },
    {
        id: 'Central Asia Standard Time',
        label: 'Central Asia (GMT+6)',
        offset: '+06:00'
    },
    {
        id: 'Bangladesh Standard Time',
        label: 'Bangladesh (GMT+6)',
        offset: '+06:00'
    },
    {
        id: 'China Standard Time',
        label: 'China (GMT+8)',
        offset: '+08:00'
    },
    {
        id: 'Singapore Standard Time',
        label: 'Singapore (GMT+8)',
        offset: '+08:00'
    },
    {
        id: 'Tokyo Standard Time',
        label: 'Tokyo (GMT+9)',
        offset: '+09:00'
    },
    {
        id: 'Australia/Sydney',
        label: 'Australia Eastern (GMT+10/+11)',
        offset: '+10:00/+11:00'
    },
    {
        id: 'New Zealand Standard Time',
        label: 'New Zealand (GMT+12/+13)',
        offset: '+12:00/+13:00'
    },
    {
        id: 'US Eastern Standard Time',
        label: 'US Eastern (GMT-5/-4)',
        offset: '-05:00/-04:00'
    },
    {
        id: 'Central Standard Time',
        label: 'US Central (GMT-6/-5)',
        offset: '-06:00/-05:00'
    },
    {
        id: 'Mountain Standard Time',
        label: 'US Mountain (GMT-7/-6)',
        offset: '-07:00/-06:00'
    },
    {
        id: 'Pacific Standard Time',
        label: 'US Pacific (GMT-8/-7)',
        offset: '-08:00/-07:00'
    },
    {
        id: 'Alaskan Standard Time',
        label: 'Alaska (GMT-9/-8)',
        offset: '-09:00/-08:00'
    },
    {
        id: 'Hawaiian Standard Time',
        label: 'Hawaiian (GMT-10)',
        offset: '-10:00'
    },
    {
        id: 'Atlantic Standard Time',
        label: 'Atlantic (GMT-4/-3)',
        offset: '-04:00/-03:00'
    },
    {
        id: 'Canada Central Standard Time',
        label: 'Canada Central (GMT-6/-5)',
        offset: '-06:00/-05:00'
    },
    {
        id: 'Argentina Standard Time',
        label: 'Argentina (GMT-3)',
        offset: '-03:00'
    },
    {
        id: 'South Africa Standard Time',
        label: 'South Africa (GMT+2)',
        offset: '+02:00'
    },
    {
        id: 'Mauritius Standard Time',
        label: 'Mauritius (GMT+4)',
        offset: '+04:00'
    },
    {
        id: 'Arab Standard Time',
        label: 'Arab Standard (GMT+3)',
        offset: '+03:00'
    },
    {
        id: 'AUS Central Standard Time',
        label: 'Australia Central (GMT+9:30/+10:30)',
        offset: '+09:30/+10:30'
    },
    {
        id: 'AUS Eastern Standard Time',
        label: 'Australia Eastern (GMT+10/+11)',
        offset: '+10:00/+11:00'
    }
];

/**
 * Get timezone list formatted for display in dropdowns
 */
export function getTimezoneOptions(): any[] {
    return TIMEZONE_IDS.map(tz => ({
        id: tz.id,
        label: `${tz.label} (${tz.offset})`
    }));
}

/**
 * Get timezone by ID
 */
export function getTimezoneById(id: string): any {
    return TIMEZONE_IDS.find(tz => tz.id === id);
}

/**
 * Default timezone (UTC)
 */
export const DEFAULT_TIMEZONE_ID = 'UTC';
